var exports = {
  "kL": "ReportFlowSummary.module__container___QjdsTk",
  "ed": "ReportFlowSummary.module__disclaimer___QjdsTk",
  "uW": "ReportFlowSummary.module__section___QjdsTk",
  "R_": "ReportFlowSummary.module__heading___QjdsTk",
  "GA": "ReportFlowSummary.module__answers___QjdsTk",
  "ZF": "ReportFlowSummary.module__answer___QjdsTk",
  "yy": "ReportFlowSummary.module__answerText___QjdsTk",
};

module.exports = exports;
